import React from "react";
import { Button } from "./Button";
import { TileData } from "./HorizontalTile";

interface SquaredTileProps extends TileData {
  onLearnMore: (tileData: TileData) => void;
  key: string;
  backgroundColor?: string;
}

export const SquaredTile: React.FC<SquaredTileProps> = ({ 
  title, 
  text, 
  image, 
  imageStyle, 
  onLearnMore,
  fullText,
  actionButton,
  key,
  backgroundColor,
}) => (
  <div 
    key={key} 
    className="whats-new-tile !flex !flex-col items-center !w-full !min-h-[500px] sm:!min-h-[400px] lg:!min-h-[450px] !pb-0"
    style={{ backgroundColor: backgroundColor }}
  >

    <div className="flex flex-col items-start w-full px-2 sm:px-4 lg:px-6">
      <h4 className="whats-new-tile-title !font-roboto !w-full !text-center pt-4 sm:pt-6 lg:pt-8 xl:pt-10">
        {title}
      </h4>
      <span className="whats-new-tile-text !mt-2 !sm:mt-3 !lg:mt-4 !xl:mt-6 !sm:mb-2 !lg:mb-3 !xl:mb-4 !text-center !mr-0 !pr-0 !w-full !leading-relaxed line-clamp-2 !font-[300]">
        {text}
      </span>
    </div>
    
    <img
      style={imageStyle}
      className="w-full max-w-[300px] sm:max-w-[350px] lg:max-w-[400px] h-auto max-h-[200px] sm:max-h-[230px] lg:max-h-[270px] relative object-contain rounded-lg mt-4"
      src={image}
      alt={title + " image"}
    />
    
    <div className="flex-grow"></div>
    
    <div className="flex flex-row justify-end w-full pr-[0%] sm:pr-[3%] lg:pr-[3%] xl:pr-[5%] pb-[3px] sm:pb-[25px] xl:pb-[37px] pt-[20px] lg:pt-[25px] xl:pt-[30px]">
      <Button 
        text="LEARN MORE" 
        rightIcon="+" 
        onClick={() => onLearnMore({ title, text, image, imageStyle, fullText, actionButton })}
        style={{ paddingBottom: "0px" }}
      />
    </div>
  </div>
);
